import React from 'react';
import './FormattedMethodSignature.css';

interface FormattedMethodSignatureProps {
  method: string;
}

/** Syntax-highlighted method signature (shared with onboarding wizard). */
const FormattedMethodSignature: React.FC<FormattedMethodSignatureProps> = ({ method }) => {
  const match = method.match(/^(\w+)\((.*)\)$/);

  if (!match) {
    return <span className="method-sig-plain">{method}</span>;
  }

  const methodName = match[1];
  const paramsString = match[2];
  const params = paramsString ? paramsString.split(',').map((p) => p.trim()) : [];

  return (
    <span className="method-sig">
      <span className="method-sig-name">{methodName}</span>
      <span className="method-sig-paren">(</span>
      {params.map((param, index) => {
        const paramMatch = param.match(/^(\S+)(?:\s+(\S+))?$/);
        if (!paramMatch) {
          return (
            <span key={index} className="method-sig-param">
              {param}
            </span>
          );
        }

        const paramType = paramMatch[1];
        const paramName = paramMatch[2];

        return (
          <React.Fragment key={index}>
            <span className="method-sig-type">{paramType}</span>
            {paramName && <span className="method-sig-arg">{` ${paramName}`}</span>}
            {index < params.length - 1 && <span className="method-sig-comma">, </span>}
          </React.Fragment>
        );
      })}
      <span className="method-sig-paren">)</span>
    </span>
  );
};

export default FormattedMethodSignature;
